import React, {useEffect, useState } from "react";

function Search(props) {
  const { search, count } = props;

  const [filterList, setFilterList] = useState(search);

  useEffect(()=>{
    setFilterList(search);
  },[count]);

  const handleSearch = (event) => {
    if (event.target.value === "") {
      setFilterList(search);
      return;
    }
    const searchValue = search.filter((item) =>
      item.toLowerCase().indexOf(event.target.value.trim().toLowerCase()) !== -1
    );
    setFilterList(searchValue);
  };

  return (
    <div className="search">
      <div>
        Search: <input name="query" type="text" onChange={handleSearch} />
      </div>
      <table className="lap-table">
        <thead>
          <tr>
            <th>SI.NO</th>
            <th>LAP</th>
          </tr>
        </thead>
        <tbody>
          {filterList &&
            filterList.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default Search;
